import React, {useEffect, useState, useRef} from "react";
import {makeStyles} from "@material-ui/styles";
import {Select, MenuItem, InputLabel, FormControl} from "@material-ui/core";
import axios from "axios";
import {useReactToPrint} from "react-to-print";
import Loading from "app/components/Loading";
import {Button} from "react-bootstrap";
import {format} from "date-fns";

const useStyles = makeStyles({
    container: {
        width: "100%",
        height: "100vh",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        padding: "20px",
        gap: "20px",
    },
    report: {
        width: "500px",
        padding: "20px",
        background: "#FFFFFF",
        boxShadow: "rgba(0, 0, 0, 0.24) 0px 3px 8px",
        borderRadius: "8px",
        overflowY: "auto",
        '@media print': {
            width: '100%',
        },
    },
    reportTitle: {
        fontSize: "18px",
        fontWeight: "bold",
        textTransform: "uppercase",
        textAlign: "center",
        '@media print': {
            fontSize: '100px',
            marginBottom: '40px'
        },
    },
    reportDate: {
        fontSize: "14px",
        textAlign: "center",
        '@media print': {
            fontSize: '40px',
        },
    },
    line: {
        width: "100%",
        border: "1px dashed #000000",
        marginBlock: "4px",
        '@media print': {
            borderWidth: '4px',
            marginBottom: "20px"
        },
    },
    text: {
        '@media print': {
            fontSize: '50px',
        },
    },
    order: {
        backgroundColor: "#000000",
        display: "flex",
        justifyContent: "center",
        width: "20px",
        height: "20px",
        paddingInline: "4px",
        borderRadius: "4px",
        color: "#FFFFFF",
        overflow: "hidden",
        marginRight: "4px",
        '@media print': {
            width: "60px",
            height: "80px",
        },
    },
    filter: {
        width: "500px",
    }
});


export default function WeeklyReport() {
    const [data, setData] = useState(null);
    const [isLoading, setIsLoading] = useState(true);
    const [weeks, setWeeks] = useState([]);
    const [selectedWeek, setSelectedWeek] = useState("");

    const componentRef = useRef();

    const handlePrint = useReactToPrint({
        content: () => componentRef.current,
    });

    const classes = useStyles();

    const getReport = () => {
        axios
            .get(`reports/agentWeeklyBalanceReport${selectedWeek && `?id=${selectedWeek}`}`)
            .then(({data}) => {
                setData(data);
            })
            .catch(({response}) => {
                const err = response?.data?.message ? response?.data?.message : "An error occurred.";
                console.log(err)
            })
            .finally(() => setIsLoading(false))
    }

    const getWeeks = () => {
        setIsLoading(true);
        axios.get('reports/weeks')
            .then(({data}) => {
                setWeeks(data ?? []);
                setSelectedWeek(data?.[0]?.id ?? "")
            })
            .catch()
            .finally(() => setIsLoading(false))
    }

    useEffect(() => {
        getWeeks();
    }, [])

    useEffect(() => {
        if(selectedWeek) {
            getReport();
        }
    }, [selectedWeek])

    return (
        <div className={classes.container}>
            <div className={classes.filter}>
                <FormControl className="w-100">
                    <InputLabel htmlFor="role">Tarix aralığı seçin</InputLabel>
                    <Select value={selectedWeek} onChange={(e) => setSelectedWeek(e.target.value)}>
                        {weeks.map(week => (
                            <MenuItem value={week.id} key={week.id}>{week.weekDate}</MenuItem>
                        ))}
                    </Select>
                </FormControl>
            </div>
            <div className={classes.report} ref={componentRef}>
                {
                    isLoading
                        ? <Loading/>
                        : <>
                            <h1 className={classes.reportTitle}>HƏFTƏLİK BALANS HESABATI</h1>

                            <div className={`d-flex justify-content-between ${classes.text}`}>
                                <span className="font-weight-bold">Çap tarixi</span>
                                <span>{format(new Date(), 'dd/MM/yyyy HH:mm:ss')}</span>
                            </div>
                            <div className={`d-flex justify-content-between ${classes.text}`}>
                                <span className="font-weight-bold">Kassir ID</span>
                                <span>{data?.agentNumber}</span>
                            </div>

                            <div className={`d-flex justify-content-between ${classes.text}`}>
                                <span className="font-weight-bold">Dövr</span>
                                <span>{data?.startDate && format(new Date(data?.startDate), 'dd/MM/yyyy')} - {data?.endDate && format(new Date(data?.endDate), 'dd/MM/yyyy')}</span>
                            </div>
                            <div className={`mt-2 ${classes.line}`}></div>
                            <table className="w-100">
                                <thead>
                                <tr>
                                    <td><p className={`pr-2 d-flex ${classes.text}`}><span
                                        className={classes.order}>1</span> Satışlar</p></td>
                                    <td><p className={`pr-2 ${classes.text}`}><b>Kom</b></p></td>
                                    <td><p className={`pr-2 ${classes.text}`}><b>Cəmi</b></p></td>
                                </tr>
                                </thead>
                                <tbody>
                                <tr>
                                    <td className={`pr-2 ${classes.text}`}>
                                        {/*{data?.soldTicketsCount}*/}
                                    </td>
                                    <td className={`pr-2 ${classes.text}`}>{data?.grossSalesCommission}</td>
                                    <td className={`pr-2 ${classes.text}`}>{data?.grossSales}</td>
                                </tr>
                                </tbody>
                                <thead>
                                <tr>
                                    <td><p className={`pr-2 d-flex ${classes.text}`}><span
                                        className={classes.order}>2</span> Ləğvlər</p></td>
                                    <td className={`pr-2 ${classes.text}`}><p className="pr-2"><b>Kom</b></p></td>
                                    <td className={`pr-2 ${classes.text}`}><p className="pr-2"><b>Cəmi</b></p></td>
                                </tr>
                                </thead>
                                <tbody>
                                <tr>
                                    <td className={`pr-2 ${classes.text}`}>
                                        {/*{data?.cancelledTicketsCount}*/}
                                    </td>
                                    <td className={`pr-2 ${classes.text}`}>{data?.paidCancellationCommission}</td>
                                    <td className={`pr-2 ${classes.text}`}>{data?.paidCancellation}</td>
                                </tr>
                                </tbody>
                                <thead>
                                <tr>
                                    <td><p className={`pr-2 d-flex ${classes.text}`}><span
                                        className={classes.order}>3</span> Ödənişlər</p></td>
                                    <td><p className={`pr-2 ${classes.text}`}><b>Kom</b></p></td>
                                    <td><p className={`pr-2 ${classes.text}`}><b>Cəmi</b></p></td>
                                </tr>
                                </thead>
                                <tbody>
                                <tr>
                                    <td className={`pr-2 ${classes.text}`}>
                                        {/*{data?.paidTicketCount}*/}
                                    </td>
                                    <td className={`pr-2 ${classes.text}`}>{data?.netPaymentCommission}</td>
                                    <td className={`pr-2 ${classes.text}`}>{data?.netPayment}</td>
                                </tr>
                                </tbody>
                            </table>
                            <div className={classes.line}></div>
                            <div className="d-flex justify-content-between">
                                <span className={classes.text}><b>Net satış</b></span>
                                <span className={classes.text}>{data?.netSalesTotal}</span>
                            </div>
                            <div className="d-flex justify-content-between">
                                <span className={classes.text}><b>Yekun xidmət haqqı</b></span>
                                <span className={classes.text}>{data?.commissionsTotal}</span>
                            </div>
                            <div className="d-flex justify-content-between">
                                <span className={classes.text}><b>Net ödəniş</b></span>
                                <span className={classes.text}>{data?.netPaymentsTotal}</span>
                            </div>
                            <div className="d-flex justify-content-between">
                                <span className={classes.text}><b>Limit artımı</b></span>
                                <span className={classes.text}>{data?.limitIncrease}</span>
                            </div>
                            <div className="d-flex justify-content-between">
                                <span className={classes.text}><b>Debit/Kredit</b></span>
                                <span className={classes.text}>{data?.agentDebitBalance}</span>
                            </div>
                        </>
                }
            </div>
            <Button onClick={handlePrint}>Çap et</Button>
        </div>
    )
}
